import { useState } from "react";
import { Stack, Text } from "@fluentui/react";
import { ChevronDown16Regular, ChevronUp16Regular } from "@fluentui/react-icons";
import type { TurnCitation } from "../chatTurn";
import styles from "../Answer/Answer.module.css";

interface OtherLinksProps {
  otherLinks: TurnCitation[];
  onCitationClicked: (filePath: string, citationText?: string) => void;
}

export const OtherLinks = ({ otherLinks, onCitationClicked }: OtherLinksProps) => {
  const [expanded, setExpanded] = useState(false);

  if (!otherLinks || otherLinks.length === 0) return null;

  return (
    <Stack.Item style={{ marginTop: "30px" }}>
      <Stack tokens={{ childrenGap: 4 }} style={{ marginLeft: "36px" }}>
        <button
          type="button"
          onClick={() => setExpanded(prev => !prev)}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 0,
            textAlign: "left",
            display: "flex",
            alignItems: "center"
          }}
        >
          <Text variant="medium" className={styles.citationHeader} styles={{ root: { fontWeight: 700 } }}>
            Other Links
          </Text>
          {expanded ? (
            <ChevronUp16Regular style={{ marginLeft: "4px", verticalAlign: "middle" }} />
          ) : (
            <ChevronDown16Regular style={{ marginLeft: "4px", verticalAlign: "middle" }} />
          )}
        </button>
        {expanded && (
          <Stack horizontal wrap tokens={{ childrenGap: 5 }}>
            {otherLinks.map(link => (
              <a
                key={link.url}
                className={styles.citation}
                onClick={e => {
                  e.preventDefault();
                  if (link.url) {
                    onCitationClicked(link.url, link.snippet || link.title);
                  }
                }}
              >
                {link.title}
              </a>
            ))}
          </Stack>
        )}
      </Stack>
    </Stack.Item>
  );
};
